<template>
	<div>
		<mt-popup v-model:show="showPicker" position="bottom" style="width: 100%;">
			<van-picker ref="picker" :show-toolbar="true" title="选择年份" :columns="columns" @confirm="onConfirm"
				@cancel="onCancel" />
		</mt-popup>
	</div>
</template>

<script>
export default {
	name: 'Picker',
	data() {
		return {
			showPicker: false, // 控制选择器的显示与隐藏
			selectedValue: '', // 存储用户选择的值
			columns: [], // 选择器的选项
		}
	},
	methods: {
		onConfirm(year) {
			this.selectedValue = year;
			this.showPicker = false;
			this.$emit("refreshHomeYear", year)
		},
		onCancel() {
			this.showPicker = false;
		},
		showSelectedYear(selectedYear) {
			var t = this;
			this.axios.get(this.$route.meta.yearUrl)
				.then(function (e) {
					t.columns = e.data.data;
				})
				.catch(function (error) { // 请求失败处理
					console.log(error);
				});
			
			if (selectedYear === null) {
				this.$refs.picker.setIndexes([0]);
				this.selectedValue = new Date().getFullYear();
			} else {
				this.selectedValue = selectedYear;
			}

			this.showPicker = true;
		}
	}
}
</script>